import { Component, h } from 'preact'
import { FilterSelectorComponent, FilterSelectorState } from './interfaces'
import InputGroup from '../../ui-components/InputGroup'

class RadioFilterSelector extends Component<FilterSelectorComponent, FilterSelectorState> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      data: props.selectedFilterItems
    }
  }

  setData = (data: string) => {
    this.setState({ data })
  }

  render ({ id, name, items, selectedFilterItems, children } : FilterSelectorComponent, { data }: FilterSelectorState) {
    return <div>
      <div className='overview__filters-box-content'>
        {items.map(item => {
          const checked = data === item.value
          return <div>
            <InputGroup
              inline
              key={item.id}
              name={name}
              value={item.value}
              title={item.name}
              type='radio'
              formGroupClasses='overview__filters-box-filter'
              checked={checked}
              onChange={() => this.setData(item.value)} />
          </div>
        })}
      </div>
      { children[0]({
        data,
        isApplyButtonDisabled: data === null }) }
    </div>
  }
}

export default RadioFilterSelector
